module.exports = __webpack_public_path__ + "cania-programas.f0a72525dd4978dc2460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconos/fonts/cania-programas.svg?s2o10a
// module id = 1288
// module chunks = 2